module.exports = __webpack_public_path__ + "img/top-bg-question.1fb794a3.jpg";